import React from "react";
import { useCartCount } from "./cart";
import { useStoreOpen } from "../storeSwitch/storeOpen";

/** " (2)" after the store tab when the cart holds something; nothing otherwise, or while the store is closed. */
export const StoreCount: React.FC = () => {
  const count = useCartCount();
  const open = useStoreOpen();
  if (count === 0 || !open) return null;
  return (
    <span aria-label={`${count} in cart`} style={{ fontWeight: 800, color: "#f239ff" }}>
      {" "}({count})
    </span>
  );
};
